export const DANH_MUC_THU_KHAC_PERMISSION_CODES = {
  WEB_BH_DANH_MUC_THU_KHAC_LIST: 'WEB_BH_DANH_MUC_THU_KHAC_LIST',
  WEB_BH_DANH_MUC_THU_KHAC_ADD: 'WEB_BH_DANH_MUC_THU_KHAC_ADD',
  WEB_BH_DANH_MUC_THU_KHAC_EDIT: 'WEB_BH_DANH_MUC_THU_KHAC_EDIT',
  WEB_BH_DANH_MUC_THU_KHAC_DELETE: 'WEB_BH_DANH_MUC_THU_KHAC_DELETE',
} as const

export const DANH_MUC_THU_KHAC_MUTATE_PERMISSIONS = [
  DANH_MUC_THU_KHAC_PERMISSION_CODES.WEB_BH_DANH_MUC_THU_KHAC_ADD,
  DANH_MUC_THU_KHAC_PERMISSION_CODES.WEB_BH_DANH_MUC_THU_KHAC_EDIT,
  DANH_MUC_THU_KHAC_PERMISSION_CODES.WEB_BH_DANH_MUC_THU_KHAC_DELETE,
] as const
